import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import FormWithStepsRenderer from '@/modules/FML/components/FormWithStepsRenderer.vue'
import QButton from '@/modules/shared/components/QButton.vue'

type Slugs = {
	slug: string
	submitted: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FmlCard',
  props: {
    value: { default: 0 },
    slugs: { default: () => ([] as Slugs[]) },
    title: { default: '' },
    content: { default: '' },
    hasSubmitted: { type: Boolean, default: false },
    doNotSubmitFml: { type: Boolean, default: false },
    hideControls: { type: Boolean, default: false },
    enableSubmittedTabs: { type: Boolean, default: false },
    color: { default: 'q_green_1' },
    loading: { type: Boolean, default: false },
    elevation: null
  },
  emits: ["input", "acknowledgeAndClose", "snoozeAndClose"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'input', v: number): void;
	(e: 'acknowledgeAndClose', v?: string): void;
	(e: 'snoozeAndClose'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, slugs: Slugs[], title: string, content: string, hasSubmitted: boolean, doNotSubmitFml: boolean, hideControls: boolean, enableSubmittedTabs: boolean, color: string, loading: boolean, elevation?: number | string }





const currentSlugIndex = computed({
	get () { return props.value },
	set (v: number) { emit('input', v) },
})

const hasTabs = computed(() => props.slugs.length > 1)
const hasTabsItems = computed(() => props.slugs.length > 0)
const isCurrentFmlSlugSubmitted = computed(() => props.slugs[currentSlugIndex.value]?.submitted)
const isAllFmlSubmitted = computed(() => props.slugs.every(item => item.submitted))

const selectNextTab = () => {
	const index = currentSlugIndex.value + 1
	currentSlugIndex.value = props.slugs.length > index ? index : props.slugs.length - 1
}

const selectPrevTab = () => {
	const index = currentSlugIndex.value - 1
	currentSlugIndex.value = index < 0 ? 0 : index
}

return { __sfc: true,props, emit, currentSlugIndex, hasTabs, hasTabsItems, isCurrentFmlSlugSubmitted, isAllFmlSubmitted, selectNextTab, selectPrevTab, FormWithStepsRenderer, QButton }
}

})